import React from "react";
import {Controller} from "react-hook-form";
import {Button, Box, Container, InputAdornment, MenuItem, TextField, Typography} from "@mui/material";
import {getsvkCdList, getServiceForm} from "../../../api/client";


export default function Step1(props) {
  const loadParams = (nm) => {
    return sessionStorage.getItem(nm) || "";
  };
  const saveParams = (nm, val) => {
    return sessionStorage.setItem(nm, val);
  };
  const loadJson = (nm) => {
    return JSON.parse(sessionStorage.getItem(nm)) || [];
  };
  const saveJson = (nm, val) => {
    return sessionStorage.setItem(nm, JSON.stringify(val));
  };
  async function nextStep(val) {
    const svsArr = val.svsCd.split("_");
    const params = {ymdDt: loadParams("editScheduleDate"), bsJg: loadParams("jgCd"), riyoNo: loadParams("riyoNo"), svsCd: svsArr[0], sjSvsCd: svsArr[1]};
    const hourfDt = val.hourfDt;
    const hourtDt = val.hourtDt;
    if (!Boolean(svsArr)) {
      props.errorFunc({response: {data: {errors: "サービス種類を選択してください。"}}})
    } else if (!Boolean(hourfDt) || !Boolean(hourtDt)) {
      props.errorFunc({response: {data: {errors: "提供時間を入力してください。"}}})
    } else {
      const svsForm = await getServiceForm(params).catch(error => props.errorFunc(error));
      if (Boolean(svsForm)) {
        saveJson("svsForm", svsForm.data);
        if (!Boolean(svsForm.data.length)) {
          const svsCd = val.svsCd;
          const hourfDt = val.hourfDt;
          const svkCdList = await getsvkCdList({ymdDt: props.propState.date, bsJg: props.propState.jgCd, riyoNo: props.propState.riyoNo, svsCd: svsCd, hourfDt: hourfDt, array: {}}).catch(error => props.errorFunc(error));
          if (Boolean(svkCdList)) {
            saveJson("svkCdList", svkCdList.data);
            props.setState({...props.state, activeStep: props.state.activeStep + 2});
            saveParams("activeStep", props.state.activeStep + 2);
            // props.setValue("svkCd", Boolean(svkCdList.data) ? svkCdList.data[0][0] : "");
          }
        } else {
          props.setState({...props.state, activeStep: props.state.activeStep + 1});
          saveParams("activeStep", props.state.activeStep + 1);
        };
      };
    };
  };

  return (
    <Container>
      <Box
        sx = {{display: "flex", mt: 2, mb: 2}}
      >
        <Controller
          control = {props.control}
          defaultValue = {loadJson("svsList")[0][0]}
          name = "svsCd"
          render = {({field}) => (
            <TextField
              fullWidth
              label = "サービス種類"
              SelectProps = {{MenuProps: {style: {maxHeight: 200}}}}
              select
              size = "small"
              sx = {{textAlign: "left"}}
              {...field}
            >
              {loadJson("svsList").map((svs) => (
                <MenuItem
                  key = {"svs" + svs[0]}
                  value = {svs[0]}
                >
                  {svs[1]}
                </MenuItem>
              ))}
            </TextField>
          )}
        />
      </Box>
      <Box
        sx = {{display: "flex", mt: 2, mb: 2}}
      >
        <TextField
          fullWidth
          inputProps = {{style: {textAlign: "center"}}}
          InputProps = {{
            startAdornment:
              <InputAdornment position="start">
                提供時間
              </InputAdornment>
          }}
          size = "small"
          sx = {{mb: 1}}
          type = "time"
          variant = "standard"
          {...props.register("hourfDt")}
        />
        <TextField
          fullWidth
          inputProps = {{style: {textAlign: "center"}}}
          InputProps = {{
            startAdornment:
              <InputAdornment position="start">
                ～
              </InputAdornment>
          }}
          size = "small"
          sx = {{mb: 1, width: "60%"}}
          type = "time"
          variant = "standard"
          {...props.register("hourtDt")}
        />
      </Box>
      <Box
        sx = {{display: "flex", mt: 2, mb: 2}}
      >
        <Button
          className = "btn-prev"
          onClick = {() => {
            props.setPropState({...props.propState, edit: false});
            sessionStorage.removeItem("edit");
            sessionStorage.removeItem("editScheduleStepper");
            sessionStorage.removeItem("svsList");
          }}
          sx = {{display: "block", mr: "auto", pt: 0.5, pb: 0.5, width: 120}}
        >
          <Typography
            className = "btn-txt-sm"
          >
            キャンセル
          </Typography>
        </Button>
        <Button
          className = "btn-submit"
          onClick = {() => nextStep(props.getValues())}
          sx = {{display: "block", ml: "auto", pt: 0.5, pb: 0.5, width: 120}}
        >
          <Typography
            className = "btn-txt-sm"
          >
            次へ
          </Typography>
        </Button>
      </Box>
    </Container>
  );
};
